import { ChevronRight as ArrowRightIcon } from "lucide-react";
import Flag from "@components/Flag";
import type { LinkProps } from "next/link";
import Link from "next/link";

import type { Market } from "@features/market/config/i18n-config";
import { languageName } from "@features/market/config/market-config";

type RichTextLinkProps = Omit<LinkProps, "href"> & {
  href: string;
  market: Market;
};

const RichTextMarketLink = ({ href, market, ...props }: RichTextLinkProps) => {
  const language = languageName(market.languageCode);

  return (
    <Link
      href={href}
      className="group flex items-center space-x-2 no-underline"
      {...props}
    >
      <Flag
        code={market.countryCode}
        className="h-10 w-10 flex-none rounded-full"
      />
      <span className="flex flex-1 flex-col group-hover:underline">
        <span className="text-lg">{market.countryName}</span>
        <span className="text-sm">({language})</span>
      </span>
      <ArrowRightIcon strokeWidth={1} className="size-5 flex-none" />
    </Link>
  );
};

RichTextMarketLink.displayName = "RichTextMarketLink";

export default RichTextMarketLink;
